import { AccountViewer } from "components/form/graphql/types";

export const canDeleteUserGroupRole = (viewer: AccountViewer | undefined): boolean =>
  !!viewer?.admin;
